<form (ngSubmit)="onSubmit()" novalidate>
  <section>
    <mat-form-field>
      <input
        type="text"
        placeholder="Add Group"
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="updateGroups($event)"
        [displayWith]="displayOption"
        >
        @for (option of filteredGroups; track option) {
          <mat-option [value]="option">
            {{option.title }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <section>
      <h2>Existing groups</h2>
      @if (!userGroups.value.length) {
        <p>The user has no assigned groups</p>
      }
      @if (userGroups.value) {
        <ul>
          @for (group of userGroups.value; track group) {
            <li>
              <span>{{ group['title'] }}</span
                ><span
                ><button
                (click)="deleteItem(group)"
                mat-icon-button
                matTooltip="Remove user from group"
                type="button"
                >
                <mat-icon>delete</mat-icon>
              </button></span
              >
            </li>
          }
        </ul>
      }
    </section>
  </section>
</form>
